export const cardValues: Array<number> = [
  11, 2, 3, 4, 5, 6, 7, 8, 9, 10, 10, 10, 10,
];



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/games/blackjack/models/card-values.model.ts